import { AxiosError } from "axios";
import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import adminAxios from "@/lib/axios";

export interface IEnrollmentsPayload {
  id?: number | string;
  page_id?: number;
  component_id?: number;
  variant?: string;
  headline?: string;
  cta_label?: string;
  cta_url?: string;
  open_in_new_tab?: boolean;
  outer_background_color?: string;
  inner_background_color?: string;
  headline_color?: string;
  cta_background_color?: string;
  cta_text_color?: string;
  headline_primary?: string;
  headline_accent?: string;
  body_paragraph_1?: string;
  body_paragraph_2?: string;
  body_paragraph_3?: string;
  /** Program Enrollments v2 stat blocks, e.g. "160 / Total Credits" */
  stat_1_value?: string;
  stat_1_label?: string;
  stat_2_value?: string;
  stat_2_label?: string;
  form_title?: string;
  legal_disclaimer_url?: string;
  privacy_policy_url?: string;
  terms_intro_text?: string;
  legal_disclaimer_link_label?: string;
  terms_between_links?: string;
  privacy_policy_link_label?: string;
  accent_color?: string;
  card_background_color?: string;
  body_text_color?: string;
  section_background_color?: string;
  otp_button_label?: string;
  otp_button_active_text_color?: string;
  otp_button_disabled_bg?: string;
  enable_lead_popup?: boolean;
  /** Enrollments v5 (About Course) — render the page lead form inline on the right instead of popup-only */
  enable_lead_form?: boolean;
  /** University course row id — lead form course locked to this programme in Program Enrollments v2 */
  bound_course_id?: number | string | null;
  /** Enrollments v3 (image-banner) fields */
  title?: string;
  description?: string;
  desktop_image?: string;
  mobile_image?: string;
  background_color?: string;
  overlay_color?: string;
  overlay_opacity?: number | string;
  title_color?: string;
  title_highlight_color?: string;
  description_color?: string;
  /** Enrollments v4 (flip-cards banner) — extends v3 with repeatable flip cards. */
  metadata?: unknown[];
  status?: boolean;
  created_by?: number;
}

export async function createEnrollments(payload: Partial<IEnrollmentsPayload>) {
  try {
    const response = await adminAxios.post(
      ADMIN_API_ENDPOINTS.ENROLLMENTS.CREATE,
      payload,
    );
    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function updateEnrollments(id: number, payload: Partial<IEnrollmentsPayload>) {
  try {
    const response = await adminAxios.put(
      ADMIN_API_ENDPOINTS.ENROLLMENTS.UPDATE(id),
      payload,
    );
    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}
